import { useState } from "react";
import MUITable from "../../../../../../common/components/mui-table/mui-table";
import "./user-dashboard-initiative-list.scss";
import DeleteConfirmationPopup from "../../../../../../common/components/delete-confirmation-popup/delete-confirmation-popup";
import CompanyDashboardEditInitiativePopup from "../../../../../company-dashboard/company-dashboard-all-objective/company-dashbaord-edit-popup/company-dashboard-edit-initiative-popup/company-dashboard-edit-initiative-popup";

const headers = [
  { key: "title", label: "Title" },
  { key: "assignedTo", label: "Assigned To" },
  { key: "startDate", label: "Start Date" },
  { key: "endDate", label: "End Date" },
  { key: "progress", label: "Progress" },
  { key: "status", label: "Status" },
];

const UserDashboardInitiativeList: any = (props: any) => {
  const {
    onRowClick,
    data,
    employeesList,
    statusListInitiatives,
    handleEditInitiative,
  } = props;
  const [isDeletePopupOpenInitiative, setIsDeletePopupOpenInitiative] =
    useState(false);
  const [deletePopupIdInitiative, setDeletePopupIdInitiative] =
    useState<any>(null);
  const [isOpenEditPopupInitiative, setIsOpenEditPopupInitiative] =
    useState(false);
  const [editInitiativeData] = useState<any>(null);
  const [listOfInitiativesData, setListOfInitiativesData] = useState<any[]>([]);
  const handleCloseEditPopupInitiative = () => {
    setIsOpenEditPopupInitiative(false);
  };
  const handleDeleteInitiative = async (deletePopupIdInitiative: any) => {
    if (!deletePopupIdInitiative) return;
    try {
      setIsDeletePopupOpenInitiative(false);
      setDeletePopupIdInitiative(null);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      <div className="user-dashboard-initiative-list-content">
        <MUITable
          columnNames={headers}
          rowsData={data}
          onRowClick={onRowClick}
          noRecordsTitle={"Please reload the page, or add new data."}
          noRecordsMessage={"Quiet zone! Nothing’s landed here for you yet."}
        />
      </div>
      <CompanyDashboardEditInitiativePopup
        isOpenAddPopup={isOpenEditPopupInitiative}
        onCancel={handleCloseEditPopupInitiative}
        initiativeData={editInitiativeData}
        listOfInitiativesData={listOfInitiativesData}
        setListOfInitiativesData={setListOfInitiativesData}
        setSelectedInitiativesData={null}
        statusListInitiatives={statusListInitiatives}
        employeesList={employeesList}
        onSave={handleEditInitiative}
      />
      {isDeletePopupOpenInitiative && (
        <DeleteConfirmationPopup
          isOpen={true}
          onClose={() => {
            setIsDeletePopupOpenInitiative(false);
            setDeletePopupIdInitiative(null);
          }}
          handleDelete={() => {
            handleDeleteInitiative(deletePopupIdInitiative);
            setIsDeletePopupOpenInitiative(false);
          }}
          deleteId={deletePopupIdInitiative}
        />
      )}
    </>
  );
};
export default UserDashboardInitiativeList;
